import { HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { CookieService } from 'ngx-cookie-service';
import { NGXLogger } from 'ngx-logger';
import { LogoutService } from 'src/app/services/api/logout/logout.service';

@Component({
  selector: 'app-menu-user',
  templateUrl: './menu-user.component.html',
  styleUrls: ['./menu-user.component.scss']
})
export class MenuUserComponent implements OnInit {

  username: string;
  isp?: string;

  constructor(
    private keycloakService: KeycloakService,
    private cookieService: CookieService,
    private logoutService: LogoutService,
    private logger: NGXLogger
  ) {
  }

  async ngOnInit() {
    this.keycloakService.getToken().then(
      (data) => {
        this.logger.setCustomHttpHeaders(new HttpHeaders({
          'authorization': 'Bearer ' + data,
          'x-access-token': 'Bearer ' + data
        }));
      }
    )
    const keycloakTokenParsed = await this.keycloakService.getKeycloakInstance().tokenParsed;
    this.username = keycloakTokenParsed['preferred_username'];
    /*
    const attributes = keycloakTokenParsed['ISP_attributes'];
    this.isp = attributes ? attributes.name : undefined;
    */
    this.isp = 'Adamo';
  }

  logout() {
    this.cookieService.deleteAll();
    localStorage.clear();
    sessionStorage.clear();
    this.keycloakService.clearToken();
    this.keycloakService.logout();
    this.logoutService.logout();
  }

}
